import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  JOB_MINUTES_REPORT_GET_JOB_LIST: createSagaAction('JOB_MINUTES_REPORT_GET_JOB_LIST'),
  JOB_MINUTES_REPORT_GET_USER_LIST: createSagaAction('JOB_MINUTES_REPORT_GET_USER_LIST'),
  JOB_MINUTES_REPORT_GET_FULL_REPORT: createSagaAction('JOB_MINUTES_REPORT_GET_FULL_REPORT')
}

// Action Creators
export const actions = {
  jobMinutesReportGetJobList: ({ filters }) => ({
    type: constants.JOB_MINUTES_REPORT_GET_JOB_LIST.ACTION,
    filters
  }),
  jobMinutesReportGetUserList: ({ filters }) => ({
    type: constants.JOB_MINUTES_REPORT_GET_USER_LIST.ACTION,
    filters
  }),
  jobMinutesReportGetFullReport: ({ filters }) => ({
    type: constants.JOB_MINUTES_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.JOB_MINUTES_REPORT_GET_JOB_LIST.ACTION:
      return { ...state, error: null, loadingJobList: true }
    case constants.JOB_MINUTES_REPORT_GET_JOB_LIST.SUCCESS:
      return { ...state, error: null, loadingJobList: false, jobList: action.payload }

    case constants.JOB_MINUTES_REPORT_GET_USER_LIST.ACTION:
      return { ...state, error: null, loadingUserList: true }
    case constants.JOB_MINUTES_REPORT_GET_USER_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingUserList: false,
        userList: action.payload
      }

    case constants.JOB_MINUTES_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.JOB_MINUTES_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/general/jobMinutesReportActions.js